import {atoz_banner, atoz_auth, atoz_cart, atoz_shop, todo1,
    todo2,
    speech_to_text_1,
    speech_to_text_2, 
    speech_to_text_3, 
    multilanguage_support1, 
    multilanguage_support2,
    chat_app_socket_io_1,
    chat_app_socket_io_2,
    expense_tracker_1,
    expense_tracker_2,
    expense_tracker_3,
    expense_tracker_4,
    } from '../assets/index.js';

export const Projects =[
    {  
        id:1, 
        image1: expense_tracker_1,
        image2: expense_tracker_2,
        image3: expense_tracker_3,
        image4: expense_tracker_4,
        translationKey: 'project6',  
        figma: "",
        github: "https://github.com/shubhamvaishnavdev/Expense-Tracker-React-App",
        link: "https://expense-tracker-react-app.onrender.com/",
    },
    {  
        id:2, 
        image1: chat_app_socket_io_1 ,
        image2: chat_app_socket_io_2 ,
        translationKey: 'project5',  
        figma: "",
        github: "https://github.com/shubhamvaishnavdev/chat_app_socket_io",
        link: "https://chat-app-socket-io-a3iy.onrender.com",
    },
    {  
        id:3, 
        image1: todo1 ,
        image2: todo2 ,
        translationKey: 'project2', 
        figma: "",
        github: "https://github.com/shubhamvaishnavdev/Todo-app-with-local-storage",
        link: "https://shubhamvaishnavdev.github.io/Todo-app-with-local-storage/",
    },
    {  
        id:4, 
        image1: speech_to_text_1 ,
        image2: speech_to_text_2 ,
        image3: speech_to_text_3 ,
        translationKey: 'project3', 
        figma: "",
        github: "https://github.com/shubhamvaishnavdev/react_speech_recognition_library_app",
        link: "https://shubhamvaishnavdev.github.io/react_speech_recognition_library_app/",
    },
    {  
        id:5, 
        image1: multilanguage_support1 ,
        image2: multilanguage_support2 ,
        translationKey: 'project4',  
        figma: "",
        github: "https://github.com/shubhamvaishnavdev/react_js_i18next_multiple_language_support_library",
        link: "",
    },
    {  
        id:6, 
        image1: atoz_banner ,
        image2: atoz_auth ,
        image3: atoz_cart ,
        image4: atoz_shop ,
        translationKey: 'project1',
        figma: "",
        github: "",
        link: "https://atozfashion.in",
    },
    
];